<template>
  <section class="relative my-32 flex-wrap lg:flex-nowrap py-10 mx-auto max-w-screen-x lg:p-9 flex">
    <div class="what-we-do-mosaic relative p-9 lg:p-0">
      <div>
        <img src="https://assets.terreirovoritadasalmas.com.br/illustrations/ogum-ld-2024x-lg.jpg" alt="">
      </div>

      <div>
        <img src="https://assets.terreirovoritadasalmas.com.br/illustrations/preto-velho-ld-2024x-wed.jpg" alt="">
      </div>
    </div>
    <div class="mx-4 md:mx-12 flex justify-center flex-col">
      <span class="text-1xl font-bold my-4 block">{{ $t('WHAT_WE_DO') }}</span>
      <span class="my-8 text-2xl md:text-4xl block">
        {{ $t('WHAT_WE_DO_TITLE') }}
      </span>
      <span>
        {{ $t('WHAT_WE_DO_DESCRIPTION') }}
      </span>

      <div class="mt-6 flex flex-col gap-2">
        <span><strong>{{ $t('MONDAYS') }}</strong>: {{ $t('MONDAYS_DESCRIPTION') }} </span>
        <span><strong>{{ $t('WEDNESDAYS') }}</strong>: {{ $t('WEDNESDAYS_DESCRIPTION') }}</span>
      </div>

      <div class="mt-8 flex">
        <nuxt-link to="/about" class="about-us-action">
          {{ $t('ABOUT_US') }}
        </nuxt-link>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>

.what-we-do-mosaic {
  min-height: 687px;

  div:first-child {
    width: 75%;
    height: 75%;
    overflow: hidden;
    object-fit: fill;

    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }

  div:last-child {
    position: absolute;
    bottom: 2.25rem;
    right: 2.25rem;
    width: 55%;
    height: 55%;
    overflow: hidden;
    object-fit: fill;

    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
}

@media (screen(md)) {
  .what-we-do-mosaic {
    min-width: 628px;
    min-height: 687px;
  }
}

.about-us-action {
  @apply p-4;
  background-color: var(--theme);
  color: #fff;

  &:hover {
    @apply opacity-65;
  }
}

@media (screen(lg)) {
  .services-mosaic {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 490px 490px;
    grid-template-areas:
    "a a d"
    "b c d";
  }


  .what-we-do-mosaic {
    max-width: 628px;
    max-height: 687px;
  }
}
</style>